import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=485e13a4&scoped=true&"
import script from "./Recruitment.vue?vue&type=script&lang=js&"
export * from "./Recruitment.vue?vue&type=script&lang=js&"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=485e13a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e13a4",
  null
  
)

export default component.exports